import React, { useState } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import axios from "axios";
import { toast } from "sonner";
import { BellRing } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function RestockDialog({ product, open, onOpenChange }) {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async () => {
    if (!/^[^@]+@[^@]+\.[^@]+$/.test(email)) { toast.error("Enter a valid email address"); return; }
    setLoading(true);
    try {
      await axios.post(`${API}/restock-requests`, { email, product_id: product.id, product_name: product.name });
      toast.success(`We'll email you when ${product.name} is back.`);
      onOpenChange(false); setEmail("");
    } catch (e) { toast.error(e.response?.data?.detail || "Something went wrong."); }
    finally { setLoading(false); }
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="bg-[#0C0C0C] border border-zinc-800 text-[#F5F5F0] rounded-none sm:max-w-md" data-testid="restock-dialog">
        <DialogHeader>
          <BellRing size={26} color="#D4AF37" strokeWidth={1.3} className="mb-2" />
          <DialogTitle className="font-serif text-3xl font-light text-left">Notify me when back</DialogTitle>
          <DialogDescription className="text-[#A1A1AA] text-left">
            {product?.name} is currently out of stock. Leave your email and we'll alert you the moment it returns.
          </DialogDescription>
        </DialogHeader>
        <div className="mt-4">
          <input value={email} onChange={(e) => setEmail(e.target.value)} type="email" placeholder="your@email.com"
            data-testid="restock-email-input" onKeyDown={(e) => e.key === "Enter" && submit()}
            className="w-full bg-transparent border-b border-zinc-600 focus:border-[#D4AF37] outline-none py-3 font-serif text-lg placeholder:text-[#52525B] transition-colors" />
          <button onClick={submit} disabled={loading} data-testid="restock-submit-btn"
            className="mt-6 w-full bg-[#D4AF37] text-black py-4 font-mono text-xs uppercase tracking-[0.2em] hover:bg-[#C5A028] transition-colors disabled:opacity-50">
            {loading ? "Submitting…" : "Notify Me"}
          </button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
